import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { useMappingService, useTrackingService } from './serviceHooks';

export const useProductEngagementTracker = (product: SimpleProduct | undefined, request: IRequestContext) => {
    const relewiseTrackingService = useTrackingService(request);
    const relewiseMappingService = useMappingService(request);

    const trackProductEngagement = (isFavorite: boolean) => {
        if (!product || !product.ItemId) {
            return;
        }

        const variantId = relewiseMappingService.mapSimpleProductToRelewiseVariantId(product);
        relewiseTrackingService.trackProductEngagement(relewiseMappingService.prefixId(product.ItemId), isFavorite, variantId);
    };

    return { trackProductEngagement };
};
